import { render, staticRenderFns } from "./usersConfig.vue?vue&type=template&id=58eb4b3c&scoped=true"
import script from "./usersConfig.vue?vue&type=script&lang=js"
export * from "./usersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb4b3c",
  null
  
)

export default component.exports